import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';  // Import the CSS for toast notifications

const FileUpload: React.FC = () => {
    const [file, setFile] = useState<File | null>(null);
    const [message, setMessage] = useState<string>('');

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleUpload = async () => {
        if (!file) {
            setMessage('Please select a file to upload');
            return;
        }

        const formData = new FormData();
        formData.append('file', file);

        try {

            const { data } = await axios.post('http://38.54.14.45:4000/API/icdmedical/uploadFile', formData);
            setMessage(data);
            toast.success('File uploaded successfully!'); // Show success toast
        } catch (error) {
            setMessage('Failed to upload file');
            toast.error('Failed to upload file'); // Show error toast
            console.error(error);
        }
    };

    return (
        <div className='container' style={{ margin: '30px' }}>
            {/* Title */}
            <h5>
                Upolad File Medical Codes <span><i className='fa-solid fa-list m-2'></i></span>
            </h5>

            {/* File upload form */}
            <div className='row'>
                <div className='input-group w-50 m-3'>
                    <input
                        type='file'
                        className='form-control'
                        id='inputGroupFile04'
                        aria-describedby='inputGroupFileAddon04'
                        aria-label='Upload'
                        onChange={handleFileChange}
                    />
                    <button
                        className='btn btn-secondary'
                        type='submit'
                        onClick={handleUpload}
                        style={{ marginLeft: '10px', padding: '8px', backgroundColor: "#007bff" }}
                    >
                        <span className='m-1'>
                            <i className='fa-solid fa-upload'></i>
                        </span>
                        Upload
                    </button>
                </div>
            </div>

            {/* ToastContainer for showing toast messages */}
            <ToastContainer />
        </div>
    );
};

export default FileUpload;
